import { Injectable } from '@angular/core';
import { CommunityService } from '@common/services/community.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PhaseJpService {
    private _cmsAppendString: string;
    private readonly appendText: string = 'interested-individual-';

    constructor(private communityService: CommunityService) {
        this.isPhasePreRegistration$
            .pipe()
            .subscribe(
                (prereg) =>
                    (this._cmsAppendString = prereg ? this.appendText : ''),
            );
    }

    get getPhaseType$(): Observable<PhaseJp> {
        return combineLatest([
            this.communityService.currentAuctionOpenForNewRegistrations$,
            this.communityService.currentAuctionOpenForDecisions$,
        ]).pipe(
            map(([openForNewRegistrations, openForDecisions]) => {
                if (openForDecisions) {
                    return PhaseJp.Acceptation;
                }
                if (openForNewRegistrations) {
                    return PhaseJp.Registration;
                }
                return PhaseJp.PreRegistration;
            }),
        );
    }

    get isPhaseAcceptation$(): Observable<boolean> {
        return this.getPhaseType$.pipe(
            map((phase) => phase === PhaseJp.Acceptation),
        );
    }

    get isPhaseRegistration$(): Observable<boolean> {
        return this.getPhaseType$.pipe(
            map((phase) => phase === PhaseJp.Registration),
        );
    }

    get isPhasePreRegistration$(): Observable<boolean> {
        return this.getPhaseType$.pipe(
            map((phase) => phase === PhaseJp.PreRegistration),
        );
    }

    get getCmsAppendString$(): Observable<string> {
        return this.isPhasePreRegistration$.pipe(
            map((phase) => (phase ? this.appendText : '')),
        );
    }

    get getCmsAppendStringStatic(): string {
        return this._cmsAppendString;
    }
}

enum PhaseJp {
    Acceptation = 'Acceptation',
    Registration = 'Registration',
    PreRegistration = 'PreRegistration',
}
